enum SearchMode {
  Basic = 0,
  Advanced = 1,
}

export default SearchMode;
